module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-motivation-getting-help-large@2x.a1722d1b.png";